export enum OrderCargoOrderAbandonedDownloadRequestSortApiKey {
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  MODIFIED_AT_ASC = "MODIFIED_AT_ASC",
  MODIFIED_AT_DESC = "MODIFIED_AT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
}

export type OrderCargoOrderAbandonedDownloadQueryParams = {
  order: OrderCargoOrderAbandonedDownloadRequestSortApiKey | null;
  creationStart?: string;
  creationEnd?: string;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number[];
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  passenger?: string[];
  dispatch?: string[];
  client?: string[];
  externalId?: string[];
  publicStatus?: string[];
};

type OrderCargoOrderAbandonedDownloadRequest = {
  order: OrderCargoOrderAbandonedDownloadRequestSortApiKey | null;
  creationStart?: string;
  creationEnd?: string;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number[];
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  passenger?: string[];
  dispatch?: string[];
  client?: string[];
  externalId?: string[];
  publicStatus?: string[];
};

export default OrderCargoOrderAbandonedDownloadRequest;
